import React from "react";

function Captcha({
  captcha,
  inputCaptcha,
  textColorClass,
  checkCaptcha,
  handleInputChange,
}) {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <label className="cs_input_label cs_heading_color">Captcha <span className="asterisk">*</span></label>
        </div>
        <div className={`col-6 captcha-render `}>
          {captcha}
        </div>
      </div>
      <div className="cs_with_icon_input">
        <input
          type="text"
          className="cs_form_field pl-3"
          id="captchaInput"
          placeholder="Enter the captcha"
          value={inputCaptcha}
          onChange={handleInputChange}
          
          />
        <span className={`${textColorClass} `}>{checkCaptcha}</span>
      </div>
      <div className="cs_height_42 cs_height_xl_25"></div>
          </>
    
  );
}

export default Captcha;
